"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var Day_1 = __importDefault(require("../Day/Day"));
var react_1 = require("react");
var Week = /** @class */ (function (_super) {
    __extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genDays = function () {
            var days = [];
            var date = _this.props.date.clone();
            var _a = _this.props, month = _a.month, selected = _a.selected, select = _a.select, from = _a.from, to = _a.to;
            for (var i = 0; i < 7; i++) {
                var clone = date.clone();
                var day = {
                    name: clone.format('dd').substring(0, 1),
                    number: clone.date(),
                    isCurrentMonth: clone.month() === month.month(),
                    isToday: clone.isSame(new Date(), 'day'),
                    date: clone,
                    disabled: _this.isDisabled(date, i)
                };
                days.push(React.createElement(Day_1.default, { day: day, selected: selected, from: from, to: to, select: select, key: i }));
                date.add(1, 'day');
            }
            return days;
        };
        _this.isDisabled = function (date, index) {
            var disabled = _this.props.disabled;
            var today = moment_timezone_1.default().startOf('day');
            var test = date.clone();
            if (disabled.past && test.isBefore(today)) {
                return true;
            }
            if (disabled.future && test.clone().startOf('day').isAfter(today)) {
                return true;
            }
            if (disabled.daysOfWeek.length && disabled.daysOfWeek.indexOf(index) !== -1) {
                return true;
            }
            if (disabled.from && test.clone().startOf('day').isBefore(moment_timezone_1.default(disabled.from).startOf('day'))) {
                return true;
            }
            if (disabled.to && test.clone().startOf('day').isAfter(moment_timezone_1.default(disabled.to).startOf('day'))) {
                return true;
            }
            return false;
        };
        return _this;
    }
    Week.prototype.render = function () {
        return (React.createElement("div", { className: "cal-row week", key: this.props.index }, this.genDays()));
    };
    return Week;
}(react_1.Component));
exports.default = Week;
